var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataAndReportingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 629 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m103.89,6.89l-.07,27.96h10.38v-17.58h433.06v17.58h10.38V6.89H103.89Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "92.32 45.99 92.32 56.37 76.88 56.37 76.88 237.99 66.5 243.57 66.5 45.99 92.32 45.99",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.32 313.92 92.32 324.3 66.49 324.3 66.49 302.52 76.87 296.95 76.87 313.92 92.32 313.92",
    style: {
      fill: "#064860"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m88.56,77.24v-7.88h-1.33v-2.21l.48-.02c.49-.02.84-.27,1.01-.73l.12-.32h2.25v11.16h-2.53Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.3,114.95v-.73c0-1.84.44-3.1,1.38-3.97.65-.6,1.82-1.21,2.67-1.65l.71-.37c.75-.42,1.02-.74,1.02-1.24,0-.88-.74-1.06-1.36-1.06-.8,0-1.55.32-2.22.95l-.35.33-1.7-1.67.32-.36c.93-1.04,2.26-1.59,3.87-1.59,1.91,0,3.95.86,3.95,3.27,0,1.03-.38,1.78-1.22,2.44-.46.36-1.13.75-1.78,1.12-.53.3-1.01.58-1.38.83-.85.58-1.02.96-1.02,1.36h5.37v2.35h-8.25Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.54,152.66c-1.67,0-2.91-.52-4.01-1.7l-.36-.39,1.93-1.61.32.35c.57.62,1.46,1.02,2.28,1.02,1.09,0,1.76-.59,1.76-1.53,0-.82-.54-1.23-1.6-1.23h-1.37v-2.26h1.31c.41,0,1.11-.12,1.11-.92,0-.43-.23-.95-1.33-.95-.65,0-1.31.19-1.81.53l-.38.25-1.38-1.69.42-.31c1-.74,2.13-1.13,3.27-1.13,1.63,0,3.53.82,3.53,3.13,0,.75-.22,1.42-.63,1.94h0c.87.52,1.32,1.39,1.32,2.59,0,2.41-1.68,3.91-4.39,3.91Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.39,191.19v-2.03h-5.41v-2.35l5.53-6.78h2.42v7.01h1.05v2.12h-1.05v2.03h-2.54Zm0-4.15v-3.4l-2.81,3.4h2.81Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.2,225.05c-2.14,0-3.3-.98-3.99-1.72l-.36-.39,1.93-1.6.32.35c.58.62,1.43.99,2.27.99,1.17,0,1.96-.75,1.96-1.87,0-1.02-.64-1.6-1.76-1.6-.48,0-1.2.13-1.78.49l-.19.12-2.16-.67.55-5.48h7.06v2.35h-5.01l-.14,1.44c.75-.29,1.54-.44,2.28-.44,2.3,0,3.68,1.41,3.68,3.76,0,3.14-2.41,4.26-4.67,4.26Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.33,309.42l.06-.55c.37-3.41,1.27-5.95,2.92-8.24h-4.96v-2.36h8.2v2.07l-.12.14c-2.33,2.7-3.08,5.36-3.48,8.51l-.06.44h-2.56Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153.01,37.18l-.71-2.07h-4.23l-.69,2.07h-3.04l4.31-11.71h3.05l4.35,11.71h-3.04Zm-1.57-4.53l-1.27-3.71-1.25,3.71h2.52Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m236.03,37.18v-11.71h5.49c2.31,0,3.75,1.24,3.75,3.23,0,1.04-.38,1.82-1.14,2.3h0s0,0,0,0c1.06.54,1.57,1.43,1.57,2.72,0,2.19-1.52,3.45-4.18,3.45h-5.49Zm5.46-2.52c1,0,1.5-.38,1.5-1.12,0-.79-.57-1.19-1.69-1.19h-2.47v2.31h2.66Zm.09-4.59c.48,0,1-.38,1-1.08,0-.6-.39-.98-1-.98h-2.75v2.06h2.75Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m330.2,37.4c-3.45,0-5.68-2.39-5.68-6.08s2.24-6.07,5.7-6.07c1.93,0,3.45.75,4.39,2.17l.26.4-2.08,1.52-.3-.37c-.42-.52-1.06-1.12-2.29-1.12-1.86,0-2.8,1.17-2.8,3.48,0,2.87,1.52,3.47,2.8,3.47.93,0,1.59-.3,2.21-1.02l.3-.34,2.11,1.51-.32.41c-1.04,1.35-2.49,2.04-4.31,2.04Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m412.9,37.18v-11.71h3.72c3.93,0,6.57,2.34,6.57,5.82s-2.7,5.89-6.57,5.89h-3.72Zm3.74-2.59c2.22,0,3.66-1.28,3.66-3.27s-1.44-3.24-3.66-3.24h-.85v6.51h.85Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "503.14 37.18 503.14 25.47 511.15 25.47 511.15 28.08 506 28.08 506 29.95 509.57 29.95 509.57 32.46 506 32.46 506 34.57 511.28 34.57 511.28 37.18 503.14 37.18",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.22,6.96v20.17h-17.53v7.72h25.63V6.96h-8.1Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368.31,252v73.12h54.34v-73.12h-54.34Zm43.96,62.73h-33.57v-52.35h33.57v52.35Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m435.16,271.66v53.46h54.34v-53.46h-54.34Zm43.96,43.07h-33.57v-32.68h33.57v32.68Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m502.02,216.33v108.79h54.34v-108.79h-54.34Zm43.95,98.4h-33.57v-88.02h33.57v88.02Z",
    style: {
      fill: "#d65e38"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.46,223.51v101.61h54.34v-101.61h-54.34Zm43.95,91.22h-33.56v-80.83h33.56v80.83Z",
    style: {
      fill: "#d65e38"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m95.55,227.95l1.19-.64c-.39.21-.79.43-1.19.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m100.32,225.38l1.38-.74c-.44.24-.9.48-1.38.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "538.74 171.45 557.64 171.5 557.64 154.58 538.74 171.45",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m285.57,185.05l-6.85,3.57v12.49h-23.11l-19.39,10.39h42.5v27.18h-79.77v-7.19s-32.82,17.59-32.82,17.59l22.43-.02v26.36h-71.56l-13.19,7.07v41.81h183.92v-138.31l-2.16-.94Zm-97.01,128.87h-74.36v-28.12h74.36v28.12Zm90.16,0h-79.77v-28.12h79.77v28.12Zm0-38.5h-79.77v-26.36h79.77v26.36Z",
    style: {
      fill: "#064860"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m557.64,84.99v-39H103.81v177.51l10.39-5.59v-8.85h16.48l19.35-10.4h-35.83s0-27.16,0-27.16h74.36v6.47s31.14-16.74,31.14-16.74c0-.04-.03-.08-.03-.12h-20.72v-27.99h73.08l10.33-5.55,13.43,5.55h73.11v27.99l-5.43-.04-.16-.07v.02l25.44,10.52s.02-.01.03-.01l-.07-.03h71.75l11.62-10.39h-2.64v-27.99h34.12l11.66-10.39h-45.78v-27.98h77.22l10.98-9.76Zm-369.08,76.12h-74.36v-27.99h74.36v27.99Zm0-38.38h-74.36v-27.98h74.36v27.98Zm0-38.36h-74.36v-28h74.36v28Zm90.16,38.36h-79.77v-27.98h79.77v27.98Zm0-38.36h-79.77v-28h79.77v28Zm90.18,38.36h-79.8v-27.98h79.8v27.98Zm0-38.36h-79.8v-28h79.8v28Zm90.15,76.74h-79.77v-27.99h79.77v27.99Zm0-38.38h-79.77v-27.98h79.77v27.98Zm0-38.36h-79.77v-28h79.77v28Zm88.21,0h-77.82v-28h77.82v28Z",
    style: {
      fill: "#064860"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m587.48,55.11l-150.23,133.77-155.03-64.07L3.22,274.77l28.12,49.41,254.37-136.37c10.3,4.27,91.5,37.85,161.62,66.81l1.45.6,177.11-158.33-38.41-41.78Zm-40.39,93.89l-100.96,90.3-.29-.12-156.43-64.61c-.86-.34-2.96-1.22-4.16-1.71l-.25-.11L36.64,305.8l-14.58-25.61.45-.25,260.35-140.03.22.09,156.91,64.79,146.47-130.55,19.94,21.7-10.51,9.41c-15.85,14.18-43.02,38.48-48.8,43.65Z",
    style: {
      fill: "#42c0b7"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAndReportingIcon);
export default __webpack_public_path__ + "static/media/data-and-reporting-icon.cf6f0cea9d32e70dad0102d31b93a37b.svg";
export { ForwardRef as ReactComponent };